import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/global.css';
import axios from 'axios'
Vue.prototype.axios = axios;
import qs from 'qs';
Vue.prototype.$qs = qs;

import Vuex from 'vuex';
Vue.use(Vuex);
import store from './store/index';


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

import {get,post,upload,download,json,put} from './request/http'
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$upload = upload;
Vue.prototype.$download = download;
Vue.prototype.$json = json;
Vue.prototype.$put = put;
Vue.config.productionTip = false;
import common from './assets/js/common';
Vue.prototype.common = common;
/*
import websocket from './assets/js/websocket';
Vue.prototype.websocket = websocket;
*/



import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';
Vue.use(VideoPlayer);

const hls = require('videojs-contrib-hls')
Vue.use(hls)


import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
Vue.use(VueAwesomeSwiper);

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload);


import 'babel-polyfill';
/* eslint-disable no-new */


/*import Promise from 'es6-promise';
Promise.polyfill();*/

/*import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);*/


router.beforeEach((to, from, next) => {
  if(to.meta.requireAuth){
    store.dispatch("setRouterTo",to.path);
    //判断是否登录
    if(!localStorage.getItem("token")){
      store.dispatch("setLoginVisible");
      router.push("/Home");
    }
    else{    //已经登录
      if(to.meta.needAdmin){
        if(store.getters.getToken.userId!=='1'&&store.getters.getToken.userId!=="f101127bf8d74d8e9762bb7439423463"){
          router.push("/Home");
        }
        else{
          next();
        }
      }
      else{
        next();
      }

    }
  }
  else{
    next();
  }

});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
